import { updateGuestEmail } from "@/api/register";
import type { UserInformation } from "@/api/signin";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

type UpdateGuestEmailArgs = {
	guestId: number;
	email: string;
};

export default function useUpdateGuestEmail(
	options?: MutationOptionsWithoutFn<UserInformation, UpdateGuestEmailArgs>,
) {
	return useMutation({
		mutationFn: ({ guestId, email }: UpdateGuestEmailArgs) =>
			updateGuestEmail(guestId, { email }),
		...options,
	});
}
